import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import { RECAPTCHA_SITE_KEY } from '../../constant'

const ReCaptcha = forwardRef(({ siteKey = RECAPTCHA_SITE_KEY, size = 'invisible', hl = 'vi', onVerify }, ref) => {
  const recaptchaRef = useRef(null)

  useImperativeHandle(ref, () => ({
    execute: async () => {
      if (recaptchaRef.current) {
        const token = await recaptchaRef.current.executeAsync()
        if (onVerify) onVerify(token)
        return token
      }
    },
    reset: () => {
      if (recaptchaRef.current) recaptchaRef.current.reset()
    },
  }))

  return <ReCAPTCHA sitekey={siteKey} size={size} ref={recaptchaRef} hl={hl} />
})

ReCaptcha.propTypes = {
  siteKey: PropTypes.string,
  size: PropTypes.oneOf(['invisible', 'normal', 'compact']),
  hl: PropTypes.string, // Language ('en', 'vi')
  onVerify: PropTypes.func,
}

export default ReCaptcha
